import Grid from "@mui/material/Grid";
import { ClientAgendaApiData, AgendaEntry, AgendaQuestionResponse, FormattedAgenda } from "./type";
import ToggleButton from '@mui/material/ToggleButton';
import React, { useEffect } from "react";
import { agendaContainer } from "../../project-agenda/project-agenda-description/styles";
import { Stack, ToggleButtonGroup, Typography } from "@mui/material";
import { formatAgendaForDisplay } from "./helper";

type Props = {
  agendaData: ClientAgendaApiData["agendas"];
};


export default function QuestionsTab({ agendaData }: Props) {
  const [agenda, setAgenda] = React.useState<FormattedAgenda | null>(null);

  useEffect(() => {
    if (agendaData.length > 0) {
      const firstFormatted = formatAgendaForDisplay(agendaData[0]);
      setAgenda(firstFormatted);
    }
  }, [agendaData]);

  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    nextAgenda: AgendaEntry | null
  ) => {
    if (nextAgenda) {
      setAgenda(formatAgendaForDisplay(nextAgenda));
    }
  };



  return (
    <Grid container>
      <Grid
        item
        xs={12}
        sm={3}
        sx={{
          overflow: "scroll",
          height: { sm: "500px", xs: "initial" },
          maxHeight: { xs: "200px", sm: "500px" },
        }}
      >
        <ToggleButtonGroup
          orientation="vertical"
          value={agendaData.find(a => a.id === agenda?.id) || null}
          exclusive
          onChange={handleChange}
          fullWidth
        >
          {agendaData.map((d) => (
            <ToggleButton
              key={d.id}
              sx={{ textTransform: "capitalize" }}
              value={d}
              aria-label={d.title || "Title not provided"}
            >
              {d.title}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </Grid>

      <Grid
        item
        xs={12}
        sm={9}
        sx={{
          overflow: "scroll",
          border: "1px solid #252B3B75",
          height: "500px",
        }}
      >
        {agenda && (
          <Grid item container sx={agendaContainer}>
            {agenda.responses.map((response, index: number) => (
              <Grid xs={12} item key={index}>
                <Stack direction={"row"} spacing={1} mr={4} mt={2}>
                  <Typography
                    fontSize={"12px"}
                    fontWeight={600}
                    sx={{ color: "#252B3B", opacity: "0.85" }}
                  >
                    Q{index + 1}.
                  </Typography>
                  <Stack flex={1} rowGap={1}>
                    <Typography
                      fontSize={"12px"}
                      fontWeight={600}
                      sx={{ color: "#484C57" }}
                    >
                      {response.ques}
                    </Typography>

                    {response.responses.map((response, idx) => (
                      <React.Fragment key={idx}>
                        <Typography
                          fontSize={"12px"}
                          fontWeight={600}
                          sx={{ color: "#484C57", opacity: "0.9" }}
                        >
                          • {response.expert_name}
                        </Typography>
                        <Grid ml={"10px"} container direction={"row"}>
                          <Grid item xs={12} sm={4} md={2}>
                            <Typography
                              fontSize={"12px"}
                              fontWeight={600}
                              sx={{ color: "#484C57", opacity: "0.75" }}
                            >
                              Response -
                            </Typography>
                          </Grid>
                          <Grid item xs={12} sm={8} md={10}>
                            <Typography
                              fontSize={"12px"}
                              fontWeight={600}
                              sx={{ color: "#099A51", opacity: "0.75" }}
                            >
                              {response?.answer}
                            </Typography>
                          </Grid>
                        </Grid>

                        {response.expert_note && (
                          <Grid ml={"10px"} container direction={"row"}>
                            <Grid item xs={12} sm={4} md={2}>
                              <Typography
                                fontSize={"12px"}
                                fontWeight={600}
                                sx={{ color: "#484C57", opacity: "0.75" }}
                              >
                                Note -
                              </Typography>
                            </Grid>
                            <Grid item xs={12} sm={8} md={10}>
                              <Typography
                                fontSize={"12px"}
                                fontWeight={500}
                                sx={{ color: "#484C57", opacity: "0.75" }}
                              >
                                {response.expert_note}
                              </Typography>
                            </Grid>
                          </Grid>
                        )}
                      </React.Fragment>
                    ))}
                  </Stack>
                </Stack>
                <hr style={{ opacity: "0.75", margin: "0.75rem 0" }} />
              </Grid>
            ))}
          </Grid>
        )}
      </Grid>
    </Grid>
  );
}
